import { useState } from 'react';
import { Button } from '../ui/button';
import useCoinbaseButton from '@/components/deposit/useCoinbaseButton';
import { useRouter } from 'next/router';
import { toast } from 'sonner';
import MoonpayDeposit from '@/pages/deposit/moonpay';
import { IExtendedRelayPKP } from '@shared/types/lit-protocol';
import SelectedDeposit from '../auth/desktop/SelectedDeposit';
import DepositAmount from '../auth/desktop/DepositAmount';
import { IoIosArrowBack } from 'react-icons/io';
import CustomDialog from '../ui/customDialog';
import MoonPayDesktop from '../auth/desktop/MoonPayDesktop';
import useGetLocation from '@/hooks/utilities/useGetLocation';
import OnramperDeposit from '@/pages/deposit/onramper';
import classNames from '@/lib/misc/classNames';
export default function DepositMethods({
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  PKP
}: {
  selectedPaymentMethod: string;
  setSelectedPaymentMethod: (method: string | null) => void;
  PKP: IExtendedRelayPKP;
}) {
  const router = useRouter();
  const [amountToSend, setAmountToSend] = useState('');
  const [openMoonPay, setOpenMoonPay] = useState(false);
  const isMoonPay = selectedPaymentMethod === 'card' || selectedPaymentMethod === 'bank';
  const [openOnramper, setOpenOnramper] = useState(false);
  const {
    useOnRamper
  } = useGetLocation();
  function toggleMoonPay() {
    setOpenMoonPay(!openMoonPay);
  }
  const {
    handleOnPress
  } = useCoinbaseButton({
    destinationWalletAddressSolana: PKP?.solanaAddress,
    destinationWalletAddressEVM: PKP?.additionalEthAddress
  });
  function handleClick() {
    if (selectedPaymentMethod === 'coinbase') {
      return handleOnPress();
    }
    if (isMoonPay) {
      toggleMoonPay();
      return;
    }
    if (selectedPaymentMethod === 'apple') {
      router.push('/deposit/onramper');
      return;
    }
    toast.info('There is no handler for this payment method');
  }
  const handleNumPadChange = (val: string) => {
    if (val?.includes('.')) {
      let parts = val.split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];
      let decimalLength = decimalPart.length;

      // Limit the decimal part to a maximum of 3 digits
      if (decimalLength > 3) {
        decimalPart = decimalPart.substring(0, 3);
      }
      // Reconstruct the value with the limited decimal part
      val = `${integerPart}.${decimalPart}`;
    }
    setAmountToSend(val);
  };
  const moonpayMethod = () => {
    if (selectedPaymentMethod == 'card') return 'credit_debit_card';
    if (selectedPaymentMethod == 'bank') return 'ach_bank_transfer';
    if (selectedPaymentMethod == 'apple') return 'apple_pay';
    if (selectedPaymentMethod == 'paypal') return 'paypal';
    if (selectedPaymentMethod == 'google') return 'google_pay';
  };
  function modalTrigger() {
    return <Button {...(parseFloat(amountToSend) < 30 || !amountToSend) && {
      disabled: true
    }} onClick={() => handleClick()} className='h-[56px] text-[14px] rounded-full bg-genius-pink hover:bg-genius-pink w-full mt-[103px]' data-sentry-element="Button" data-sentry-component="modalTrigger" data-sentry-source-file="DepositMethods.tsx">
        {parseFloat(amountToSend) < 30 || !amountToSend ? 'Minimum deposit is $30' : 'Next'}
      </Button>;
  }
  console.log('isMoonPay', isMoonPay);
  return <>
      <div onClick={() => {
      setSelectedPaymentMethod(null);
    }} className='absolute cursor-pointer left-7 top-7 text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'>
        <IoIosArrowBack className={`ml-2 mr-2 w-[16px] text-genius-cream`} width={20} height={18} data-sentry-element="IoIosArrowBack" data-sentry-source-file="DepositMethods.tsx" />{' '}
        <p>Back</p>
      </div>
      <SelectedDeposit selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={setSelectedPaymentMethod} data-sentry-element="SelectedDeposit" data-sentry-source-file="DepositMethods.tsx" />
      <DepositAmount value={amountToSend} onValueChange={handleNumPadChange} totalAmount={amountToSend} setAmountToSend={setAmountToSend} data-sentry-element="DepositAmount" data-sentry-source-file="DepositMethods.tsx" />
      {isMoonPay ? <CustomDialog hideClose={true} className={classNames('p-0 w-[480px]', openOnramper && 'w-[500px] h-[650px] ')} isOpen={openMoonPay} trigger={modalTrigger()}>
          {useOnRamper ? <>
              <div onClick={() => {
          toggleMoonPay();
        }} className='justify-center ta-c absolute cursor-pointer left-[200px] top-[14px] text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'>
                <p>Close</p>
              </div>
              <OnramperDeposit amount={amountToSend} paymentMethod={selectedPaymentMethod} onlyAllowStripe={true} />
            </> : <MoonPayDesktop setDlgOpen={toggleMoonPay} moonpayMethod={moonpayMethod()} amount={amountToSend} />}
        </CustomDialog> : modalTrigger()}
    </>;
}